export default "__VITE_ASSET__f2be5184__"